import { useSelector } from "react-redux";

export const BubbleBot = ({ content }) => {
  const price = useSelector((state) => {
    return state.price;
  });
  return (
    <div className="chat chat-start w-full">
      <div className="chat-image avatar">
        <div className="w-10 rounded-full">
          <img
            alt="robot"
            width={24}
            height={24}
            src="/image/robot_front.png"
          />
        </div>
      </div>
      <div className="chat-header">Assistant</div>
      <div className="chat-bubble w-full">
        {content?.replace("$_argent", price ? price : "")}
      </div>
    </div>
  );
};
